import { render, staticRenderFns } from "./LeadsInsights.vue?vue&type=template&id=7b56fddc&scoped=true&"
import script from "./LeadsInsights.vue?vue&type=script&lang=js&"
export * from "./LeadsInsights.vue?vue&type=script&lang=js&"
import style0 from "./LeadsInsights.vue?vue&type=style&index=0&id=7b56fddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b56fddc",
  null
  
)

export default component.exports